import { Button } from "@mantine/core"
import useExportOffers from "@features/offers/hooks/useExportOffers"
import useRefreshOffers from "@features/offers/hooks/useRefreshOffers"
import { useUser } from "@features/user"
import type { FC } from "react"
import { Trans } from "react-i18next"
import ActionToolbar from "./ActionToolbar"

const OffersActionButtons: FC = () => {
  const { data } = useUser()
  const { refreshOffers, refreshing } = useRefreshOffers()
  const { loadingImport, exportOffers, importOffers } = useExportOffers()

  return (
    <ActionToolbar>
      {data?.can.manageUsers && (
        <Button
          onClick={importOffers}
          loading={loadingImport}
          leftSection={<i className="fa fa-file-excel-o" />}
        >
          <Trans i18nKey="offers.buttons.importExcel" />
        </Button>
      )}
      {data?.can.manageUsers && (
        <Button
          onClick={exportOffers}
          leftSection={<i className="fa fa-file-excel-o" />}
        >
          <Trans i18nKey="offers.buttons.exportExcel" />
        </Button>
      )}
      <Button
        onClick={refreshOffers}
        loading={refreshing}
        leftSection={!refreshing ? <i className="fa fa-refresh" /> : undefined}
      >
        <Trans i18nKey="offers.buttons.refresh" />
      </Button>
    </ActionToolbar>
  )
}

export default OffersActionButtons
